import React, {useState, useContext} from 'react';
import PropTypes from 'prop-types';
import {Link, useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';

import AppDataContext from '../../context/AppDataContext';

import Text from '../Text';
import TourGalleryPreview from '../Gallery/TourGalleryPreview';

const TourImageCTA = ({link, tag, locationIndex, title, subtitle, ctaLinkLabel, imageUrl, imageAlt, aboutContent, moreCTALabel, onGalleryClick}) => {
  const location = useLocation();
  const {setFromTour} = useContext(AppDataContext);

  const [opened, setOpened] = useState(false);

  const handleAboutClick = () => {
    setOpened(!opened);
  };

  const handleMoreClick = () => {
    setFromTour(location.pathname);
  };

  return(
    <div
      className='image-cta'
    >
      <motion.div
        layoutId={`image-container-${imageUrl}`}
        transition={{ duration: 0.5 }}
        className='image-container'
        onClick={handleAboutClick}
      >
        <img src={imageUrl} alt={imageAlt} loading='lazy' decoding='async'/>
      </motion.div>
      <motion.h2
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        onClick={handleAboutClick}
      >
        {title}
      </motion.h2>
      {(subtitle && subtitle.length > 0) && <motion.h4
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        onClick={handleAboutClick}
      >{subtitle}</motion.h4>}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className='button-foot'
        onClick={handleAboutClick}
      >
        <div className="tag bronze-tag" dangerouslySetInnerHTML={{__html: tag}}></div>
        <span
          className={['text-link', 'cta-link', 'tour-cta-link', opened ? 'opened' : ''].join(' ')}
        >
          {ctaLinkLabel}
        </span>
      </motion.div>
      <div
        className={['tour-art-about-container', opened ? 'opened' : ''].join(' ')}
      >
        <div className='tour-art-about'>
          {
            // Loop through and build out the different component types
            (aboutContent) && aboutContent.map((section, index) => {
              switch(section.acf_fc_layout){
                case 'text':
                  return <Text key={section.acf_fc_layout + '-' + index} heading={section.heading} content={section.content} />;
                case 'gallery':
                  if (section.gallery) {
                    return <TourGalleryPreview
                      key={section.acf_fc_layout + '-' + index}
                      artId={locationIndex}
                      galleryId={index.toString()}
                      imageUrl={section.gallery[0].url}
                      imageAlt={section.gallery[0].alt}
                      numArt={section.gallery.length}
                      onGalleryClick={onGalleryClick}
                    />;
                  }
              }
            })
          }
          <Link to={link} onClick={handleMoreClick}>
            <div className='tour-art-more-cta'>
              <span>{moreCTALabel}</span><span className='chevron'></span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

TourImageCTA.propTypes = {
  link: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
  locationIndex: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  ctaLinkLabel: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  aboutContent: PropTypes.array.isRequired,
  moreCTALabel: PropTypes.string.isRequired,
  onGalleryClick: PropTypes.func
};

export default TourImageCTA;